module.exports = function (req, res, next) {};


//////////////////
// WEBPACK FOOTER
// ./middleware/customredirects.js
// module id = ./middleware/customredirects.js
// module chunks = 5